<div class="modal-header">
  <h4 class="modal-title">{{'selectProjectForCSVExportPopup.title' | translate}}
    <a class="link ps-2" href="javascript:void(0)" data-gatm="global.label.help" (click)="openHELPLink()" tooltip [tooltipText]="'global.label.help' | translate"><app-svg-icon type="information_circle" [inline]="true"/></a>
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <p>{{'selectProjectForCSVExportPopup.message' | translate}}</p>
    <div class="ps-5">
      <div class="form-check">
        <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="items[0]" [(ngModel)]="selectedItem">
        <label class="form-check-label" for="radio1" [innerHTML]="'selectProjectForCSVExportPopup.label.export_current_project' | translate"></label>
      </div>
      <div class="form-check mt-3">
        <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="items[1]" [(ngModel)]="selectedItem">
        <label class="form-check-label" for="radio2" [innerHTML]="'selectProjectForCSVExportPopup.label.export_saved_projects' | translate"></label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" data-testid="csv-select-project-confirm" (click)="next()">{{'global.label.next' | translate}}</button>
</div>
